import type { CosignatureQueueSearchParams } from "@/core/types";

export const cosignatureKeys = {
  base: ["cosignature"] as const,
  meta: (noteId: string) => [...cosignatureKeys.base, noteId, "meta"] as const,
  queue: (searchParams?: CosignatureQueueSearchParams) =>
    [...cosignatureKeys.base, "queue", searchParams] as const,
  supervisors: () => [...cosignatureKeys.base, "supervisors"] as const,
} as const;
